<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<v-form
				ref="form"
				v-model="the_address.valid"
				lazy-validation
		>
			<v-layout wrap justify-space-between>
				<v-flex xs12 md5>
					<v-layout wrap justify-space-between>
						<v-flex xs12 pb-0>
							<v-text-field
									v-if="showNameField"
									v-model="the_address.name"
									label="Name"
									required
									v-show="!onlyPhoneEditable"
									:rules="rules.name"
									class="co-text-field"
							/>

							<v-text-field
									v-model="the_address.line1"
									label="Address Line 1"
									required
									v-show="!onlyPhoneEditable"
									:rules="rules.line1"
									class="co-text-field"
							/>

							<v-text-field
									v-model="the_address.line2"
									label="Address Line 2"
									required
									v-show="!onlyPhoneEditable"
									:rules="rules.line2"
									class="co-text-field"
							/>

							<v-text-field
									v-model="the_address.city"
									label="City"
									required
									v-show="!onlyPhoneEditable"
									:rules="rules.city"
									class="co-text-field"
							/>

							<v-autocomplete
									:items="countries"
									v-model="the_address.country"
									label="Country"
									required
									v-show="!onlyPhoneEditable"
									:rules="rules.country"
									item-value="abbreviation"
									item-text="name"
									class="co-text-field"
									v-if="$globs['is_international']"
									browser-autocomplete="off"
									v-bind="ADAattr('list')"
							/>
						</v-flex>


						<v-flex xs12 md5 py-0 v-if="show_state">
							<v-autocomplete
									:items="states"
									v-model="the_address.state"
									label="State"
									:required="isUSA(the_address.country)"
									v-show="!onlyPhoneEditable"
									:rules="rules.state"
									item-value="abbreviation"
									item-text="abbreviation"
									class="co-text-field"
									browser-autocomplete="off"
									v-bind="ADAattr('list')"
							/>
						</v-flex>

						<v-flex xs12 md6 py-0>
							<v-text-field
									v-model="the_address.postal_code"
									label="Zip"
									required
									v-show="!onlyPhoneEditable"
									:rules="rules.postal_code"
									class="co-text-field"
									:return-masked-value="true"
									:mask="postal_code_mask"
							/>
						</v-flex>

						<v-flex xs12 pt-0 v-if="!this.$globs['is_vie']">
							<v-text-field
									v-model="the_address.phone"
									label="Phone"
									required
									:rules="rules.phone"
									class="co-text-field"
							/>

							<v-checkbox
									label="This is a mobile phone"
									v-model="the_address.is_mobile"
									hide-details
									class="mt-2"
							/>

							<v-text-field
                                    v-if="showLabelField && !onlyPhoneEditable"
									v-model="the_address.label"
									label="Label for this address"
									required
									:rules="rules.label"
									class="co-text-field"
							/>
						</v-flex>
						<input type="hidden" name="source" :value="the_address.source">
					</v-layout>
				</v-flex>
			</v-layout>
		</v-form>

		<v-layout row justify-center>
			<v-dialog v-model="validated_address_dialog_shown" persistent max-width="600px">
				<v-card class="pa-3 pt-4" v-bind="ADAattr('dialog', !validated_address_dialog_shown, 'ada-sca')">
					<v-card-title class="py-1" v-bind="ADAattr('h2')" id="ada-sca">
						<span class="title font-weight-bold">Select the Correct Address</span>
					</v-card-title>

					<template v-if="!unable_to_validate">
						<v-card-text class="pb-0" v-bind="ADAattr('focus')">
							According to USPS, the address you entered may be incorrect or missing some details.
							Please verify your address and choose from one of the options below, or proceed with the address as entered.
						</v-card-text>
						<v-card-text class="py-0">
							<v-radio-group v-model="validated_address_option" class="co-select-validated-address" hide-details>
								<v-container grid-list-md pa-0>
									<v-layout row wrap>
										<v-flex xs12 sm6 md6>
											<h4 class="mb-3" v-bind="ADAattr('hidden')">You Entered:</h4>
											<div class="co-select-validated-address-option" v-bind:class="{ selected: validated_address_option === 0 }">
												<v-radio :value="0" class="co-select-validated-address-radio"
													v-bind="ADAattr('label', `You entered: ${the_address.line1}, ${the_address.line2 ? `${the_address.line2},` : ''}
													${the_address.city}, ${the_address.state} ${the_address.postal_code}`)"
												>
													<template v-slot:label="">
														<v-card flat>
															<v-card-text class="pa-0">
																<div>{{ the_address.line1 }}</div>
																<div v-if="the_address.line2">{{ the_address.line2 }}</div>
																<div>{{ `${the_address.city}, ${the_address.state} ${the_address.postal_code}` }}</div>
															</v-card-text>
														</v-card>
													</template>
												</v-radio>
												<div>
													<a
														href="#"
														@click.prevent="cancelChooseValidatedAddress"
														v-bind="ADAattr('control', _.get($attrs, 'id', null), 'Edit entered shipping address')"
													>
														<v-icon color="#2170f2">edit</v-icon>
														Edit
													</a>
												</div>
											</div>
										</v-flex>
										<v-flex xs12 sm6 md6>
											<h4 class="mb-3" v-bind="ADAattr('hidden')">We Suggest:</h4>
											<div class="co-select-validated-address-option" v-bind:class="{ selected: validated_address_option === 1 }">
												<v-radio :value="1" class="co-select-validated-address-radio"
													v-bind="ADAattr('label', `We suggest: ${validated_address.line1}, ${validated_address.line2},
													${validated_address.city}, ${validated_address.state} ${validated_address.postal_code}`)"
												>
													<template v-slot:label="">
														<v-card flat>
															<v-card-text class="pa-0">
																<div>{{ validated_address.line1 }}</div>
																<div v-if="validated_address.line2">{{ validated_address.line2 }}</div>
																<div>
																	{{ `${validated_address.city}, ${validated_address.state} ${validated_address.postal_code}`
																	}}
																</div>
															</v-card-text>
														</v-card>
													</template>
												</v-radio>
											</div>
										</v-flex>
									</v-layout>
								</v-container>
							</v-radio-group>
						</v-card-text>
					</template>

					<template v-else>
						<v-card-text class="pb-0" v-bind="ADAattr('focus')">
							<div>
								We were unable to validate your address. Please verify that you entered everything correctly:
							</div>
						</v-card-text>
						<v-card-text>
							<div>{{ the_address.line1 }}</div>
							<div v-if="the_address.line2">{{ the_address.line2 }}</div>
							<div>{{ `${the_address.city}, ${the_address.state} ${the_address.postal_code}` }}</div>
						</v-card-text>
					</template>

					<v-card-actions v-if="!unable_to_validate">
						<v-spacer></v-spacer>
						<v-btn color="#2170f2" dark @click="chooseValidatedAddress(null)"
							v-bind="ADAattr('label', `Continue with ${validated_address_option === 0 ? 'entered' : 'suggested'} address`)"
						>
							Continue
						</v-btn>
					</v-card-actions>
					<v-card-actions v-else class="co-correct-address-buttons">
						<v-spacer></v-spacer>
						<v-btn color="#2170f2" dark @click="chooseValidatedAddress(0)">Use Address I Entered</v-btn>
						<v-btn color="#2170f2" dark @click="chooseValidatedAddress(2)"
							v-bind="ADAattr('control', _.get($attrs, 'id', null), 'Edit entered shipping address')"
						>
							Edit Address
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-layout>
	</div>
</template>

<script>
	import states_list from './../../common/includes/js/StatesList';
	import countries_list from './../../common/includes/js/CountriesList';
	import _ from 'lodash';
	import Axios from 'axios';
	import {EventBus} from './../includes/EventBus';
	import {parseErrorResponse, isUSA} from '../includes/Miscellaneous';

	export default {
		name: "AddEditShippingAddressForm",

		props: {
			address: {
				type: Object,
			},

			showLabelField: {
				type: Boolean,
				default: false,
			},

			disable_apo_states: {
				type: Boolean,
				default: false,
			},

			showNameField: {
				type: Boolean,
				default: false,
			},

			onlyPhoneEditable: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				states: _.filter(states_list, state => {
					return true;
				}),

				countries: _.map(countries_list, (k, v) => {
					return {
						abbreviation: v,
						name: k,
					};
				}),

				the_address: {
					valid: false,
					is_mobile: true,
					name: '', line1: '', line2: '', country: 'US',
					city: '', state: '', postal_code: '', phone: '',
					label: '', source: 'checkout',
				},

				validated_address: {
					line1: '', line2: '', city: '', state: '', postal_code: '',
				},
				unable_to_validate: false,

				validated_address_dialog_shown: false,
				validated_address_option: 1,
				validated_address_resolve: null,

				rules: {
					name: [
						v => !!v.trim() || 'Name is required',
						v => (v = /[!<>"%]+/.exec(v)) === null || 'Invalid format.' + (v[0] && v[0][0] ? ` "${v[0][0]}" character is not allowed` : ''),
					],
					line1: [
						v => !!v.trim() || 'Line 1 is required',
						v => v.length <= 24 || 'Max 24 characters',
						v => (v = /[!<>"%]+/.exec(v)) === null || 'Invalid format.' + (v[0] && v[0][0] ? ` "${v[0][0]}" character is not allowed` : ''),
					],
					line2: [
						v => v.length <= 24 || 'Max 24 characters',
						v => (v = /[!<>"%]+/.exec(v)) === null || 'Invalid format.' + (v[0] && v[0][0] ? ` "${v[0][0]}" character is not allowed` : ''),
					],
					city: [
						v => !!v.trim() || 'City is required',
						v => (v = /[!<>"%]+/.exec(v)) === null || 'Invalid format.' + (v[0] && v[0][0] ? ` "${v[0][0]}" character is not allowed` : ''),
					],
					state: [
						v => {
							if (!this.isUSA(this.the_address.country)) return true;
							return !!v || 'State is required';
						},
					],
					country: [
						v => !!(v && v.trim && v.trim()) || 'Country is required',
					],
					postal_code: [
						v => !!v.trim() || 'Postal Code is required',
						v => {
							if (this.isUSA(this.the_address.country)) {
								return v.replace('-', '').length === 5 || v.replace('-', '').length === 9 || `Zip code should contain 5 or 9 digits`;
							}

							return v.length <= 30 || `Max 30 characters`;
						},
					],
					phone: [
						v => v.replace(/[^\d]/g, '').length > 0 || 'Phone number is required',
						v => /^[\d\-\s()+]*$/.test(v) || 'Invalid format',
						v => {
							if (v.length > 20) return 'Max 20 characters';

							if (this.isUSA(this.the_address.country)) {
								return v.replace(/[^\d]/g, '').length <= 11 || `Max 11 digits`;
							}

							return true;
						},
					],
					label: [
						v => !!v.trim() || 'Invalid value',
						v => (v = /[!<>"%]+/.exec(v)) === null || 'Invalid format.' + (v[0] && v[0][0] ? ` "${v[0][0]}" character is not allowed` : ''),
					],
				},
			};
		},

		mounted() {
			const self = this;

			_.forEach(self.address, (v, k) => {
				if (k in self.the_address) {
					self.the_address[k] = v;
				}
			});

			_.forEach(_.keys(self.the_address), name => {
				self.$watch('the_address.' + name, function (value, old) {
					self.$emit('editing-address', {name, value, old});
				});
			});

		},

		methods: {
			isUSA,

			fetch() {
				const self = this;

				if (!self.show_state) {
					self.the_address.state = '';
				}

				if (!self.$refs.form.validate()) {
					return null;
				}

				return self.the_address;
			},

			isSameAddress(addr1, addr2) {
				return !_.some(_.keys(this.validated_address), key => {
					return addr1[key] !== addr2[key];
				});
			},

			validate() {
				const self = this;

				if (!self.show_state) {
					self.the_address.state = '';
				}

				if (!self.$refs.form.validate()) {
					this.$vuetify.goTo(self.$refs.form);
					return null;
				}

				if (!self.isUSA(self.the_address.country)) {
					return self.the_address;
				}

				return new Promise((resolve, reject) => {
					self.validated_address_resolve = resolve;
					self.unable_to_validate = false;
					self.validated_address_option = 1;

					Axios.post('/sc/rest/index.php/verify_address', self.the_address).then(({data}) => {
						if (data['long_address']) {

							// If long address, show address selection dialog in "unable to verify" mode
							self.unable_to_validate = true;
							self.validated_address_option = 2;

						} else {

							// If all good, show address selection dialog with corrected address
							_.forEach(_.keys(self.validated_address), (v) => {
								self.validated_address[v] = data[v];
							});
						}

						// if address is the same as validated, don't ask to choose
						if (self.isSameAddress(self.the_address, self.validated_address)) {
							self.validated_address_resolve(self.the_address);
							return;
						}

						self.validated_address_dialog_shown = true;
					}).catch(error => {
						// If error, show it's text and show address selection dialog in "unable to verify" mode
						EventBus.$emit('show-message', {
							msg: parseErrorResponse(error.response),
							severity: 2,
						});

						self.unable_to_validate = true;
						self.validated_address_option = 2;
						self.validated_address_dialog_shown = true;
					});
				});

			},

			chooseValidatedAddress(value = null) {
				const self = this;

				if (value === null) {
					value = this.validated_address_option;
				}

				if (value === 2) {
					self.cancelChooseValidatedAddress();
					return;
				}

				self.validated_address_dialog_shown = false;
				self.validated_address_resolve(
					value === 0 ? self.the_address : {
						...self.validated_address,
						name: self.the_address.name,
						phone: self.the_address.phone,
						country: self.the_address.country,
						is_mobile: self.the_address.is_mobile,
						label: self.the_address.label,
						source: self.the_address.source,
					},
				);
			},

			cancelChooseValidatedAddress() {
				const self = this;
				self.validated_address_dialog_shown = false;
				self.validated_address_resolve(null);
			},
		},
		computed: {
			show_state() {
				return !this.$globs['is_international'] || this.isUSA(this.the_address.country);
			},

			postal_code_mask() {
				if (this.isUSA(this.the_address.country)) {
					return this.the_address.postal_code.length > 5 ? '#####-####' : '#########';
				}

				return null;
			},
		},

		watch: {
			'the_address.line1': {
				handler(value, old) {
					if (this.the_address.label === '' || this.the_address.label === old) {
						this.the_address.label = value;
					}
				},
				immediate: true,
			}
		},

		beforeDestroy() {
			if (_.isFunction(this.validated_address_resolve)) {
				this.validated_address_resolve(null);
			}
		},
	};
</script>

<style scoped lang="less">
	/deep/ .co-select-validated-address {
		width: 100%;

		.co-select-validated-address-option {
			box-sizing: border-box;
			padding: 20px 10px;
			border: 2px solid transparent;

			.co-select-validated-address-radio {
				align-items: unset;
			}

			&.selected {
				border: 2px solid #ccc;
				border-radius: 4px;
			}
		}

		> .v-input__control {
			flex-grow: 1;
		}
	}

	/deep/ .v-input__control {
		flex-grow: 1 !important;
	}

	/deep/ .v-text-field .v-label {
		top: 6px !important;
	}


	.co-correct-address-buttons {
		@media screen and (max-width: 600px){
			flex-flow: column;
			button {
				margin: 5px 0;
			}
		}
	}
</style>